<template>
    <!-- Enter 로 진행: 입력 칸 어디서든 [다음] 과 같다(onEnterKey) -->
    <div @keypress.enter="onEnterKey">
        <div class="mb-4">
            <h5>{{ $t(`평가신청 기업 정보`) }}</h5>
            <!--      lg 이상의 화면의 경우          -->
            <b-table-simple bordered class="d-none d-lg-table bgray-100" fixed>
                <b-tbody>
                    <template>
                        <b-tr>
                            <b-td>
                                <p class="f-90 gray-600 fw-400 mb-1">{{
                                        $t(`업체코드`)
                                    }}</p>
                                <div>
                                    <h6 class="gray-700 text-black fw-500 f-110 mb-0">
                                        {{
                                            selected_vendor.vendor_code || '  -  '
                                        }}</h6>
                                </div>
                            </b-td>
                            <b-td>
                                <p class="f-90 gray-600 fw-400 mb-1">{{
                                        $t(`기업명 및 소재지`)
                                    }}</p>
                                <div>
                                    <h6 class="gray-700 text-black fw-500 f-110 mb-0">{{ company_label }}</h6>
                                </div>
                            </b-td>
                            <b-td v-if="tenant_register">
                                <p class="f-90 gray-600 fw-400 mb-1">
                                    {{ $t(`원청사`) }}</p>
                                <div>
                                    <h6 class="gray-700 text-black fw-500 f-110 mb-0">
                                        {{
                                            selected_vendor.hd_corporate || '  -  '
                                        }}</h6>
                                </div>
                            </b-td>
                        </b-tr>
                        <b-tr>
                            <b-td>
                                <p class="f-90 gray-600 fw-400 mb-1">{{
                                        $t(`법인등록번호`)
                                    }}</p>
                                <div>
                                    <h6 class="gray-700 text-black fw-500 f-110 mb-0">
                                        {{
                                            selected_vendor.company.corporate_code || '-'
                                        }}</h6>
                                </div>
                            </b-td>
                            <b-td>
                                <p class="f-90 gray-600 fw-400 mb-1">{{
                                        $t(`사업자등록번호`)
                                    }}</p>
                                <div>
                                    <h6 class="gray-700 text-black fw-500 f-110 mb-0">
                                        {{
                                            selected_vendor.company.company_code || '-'
                                        }}</h6>
                                </div>
                            </b-td>
                            <b-td>
                                <p class="f-90 gray-600 fw-400 mb-1">
                                    {{ $t(`DUNS Number`) }}</p>
                                <div>
                                    <h6 class="gray-700 text-black fw-500 f-110 mb-0">
                                        {{ selected_vendor.company.duns_number || '-' }}</h6>
                                </div>
                            </b-td>
                        </b-tr>
                    </template>
                </b-tbody>
            </b-table-simple>
            <!--      lg 보다 작은 화면의 경우          -->
            <b-list-group no-gutters class="d-block d-lg-none">
                <b-list-group-item>
                    <p class="f-90 gray-600 fw-400 mb-1">{{ $t(`기업명 및 소재지`) }}</p>
                    <div>
                        <h6 class="gray-700 text-black fw-500 f-110 mb-0">{{ company_label }}</h6>
                    </div>
                </b-list-group-item>
                <b-list-group-item v-if="tenant_register">
                    <p class="f-90 gray-600 fw-400 mb-1">
                        {{ $t(`원청사`) }}
                    </p>
                    <div>
                        <h6 class="gray-700 text-black fw-500 f-110 mb-0">
                            {{ selected_vendor.hd_corporate || '-' }}
                        </h6>
                    </div>
                </b-list-group-item>
                <b-list-group-item>
                    <p class="f-90 gray-600 fw-400 mb-1">{{ $t(`업체코드`) }}</p>
                    <div>
                        <h6 class="gray-700 text-black fw-500 f-110 mb-0">
                            {{ selected_vendor.vendor_code }}</h6>
                    </div>
                </b-list-group-item>
                <b-list-group-item>
                    <p class="f-90 gray-600 fw-400 mb-1">{{ $t(`법인등록번호`) }}</p>
                    <div>
                        <h6 class="gray-700 text-black fw-500 f-110 mb-0">
                            {{ selected_vendor.company.corporate_code || '-' }}</h6>
                    </div>
                </b-list-group-item>
                <b-list-group-item>
                    <p class="f-90 gray-600 fw-400 mb-1">{{ $t(`사업자등록번호`) }}</p>
                    <div>
                        <h6 class="gray-700 text-black fw-500 f-110 mb-0">
                            {{ selected_vendor.company.company_code || '-' }}</h6>
                    </div>
                </b-list-group-item>
                <b-list-group-item>
                    <p class="f-90 gray-600 fw-400 mb-1">{{ $t(`DUNS Number`) }}</p>
                    <div>
                        <h6 class="gray-700 text-black fw-500 f-110 mb-0">
                            {{ selected_vendor.company.duns_number || '-' }}</h6>
                    </div>
                </b-list-group-item>
            </b-list-group>
        </div>


        <div class="d-flex justify-content-between align-items-end pb-1">
            <label for="register-user-email" class="fw-500 mb-0">
                <span v-if="phase_step === 2">*</span> {{ $t(`이메일 (로그인 ID)`) }}
            </label>
            <!-- 로그인 ID 가 될 이메일을 잘못 쓴 경우: 업체 선택·다른 입력은 두고 이메일만 다시 확인한다 -->
            <b-link v-if="phase_step === 2" class="f-90" :disabled="calcLoading" @click="editEmail">{{ $t('이메일 수정') }}</b-link>
        </div>

        <b-form-input id="register-user-email"
                      v-model.trim="form.e_mail"
                      :disabled="phase_step !== 1 || calcLoading"
                      placeholder="ex. email@email.com"
                      autocomplete="new-password"
                      autofocus
        >
        </b-form-input>

        <template v-if="phase_step === 2 && !is_user_duplicated">
            <label for="register-user-name" class="d-block pt-3 pb-1 mb-0">* {{ $t(`성함`) }}</label>
            <b-form-input id="register-user-name" v-model.trim="form.user_name" :placeholder="$t(`성함`)"
                          :disabled="calcLoading"
                          :state="fieldState('user_name')"
            />

            <label for="register-user-password" class="d-block pt-3 pb-1 mb-0">* {{ $t(`비밀번호`) }}</label>
            <b-form-input id="register-user-password" v-model.trim="form.password" :placeholder="$t(`4자리 이상`)"
                          type="password"
                          autocomplete="new-password"
                          :disabled="calcLoading"
                          :state="fieldState('password')"
            />

            <label for="register-user-password-2" class="d-block pt-3 pb-1 mb-0">* {{ $t(`비밀번호 확인`) }}</label>
            <b-form-input
                id="register-user-password-2"
                v-model.trim="form.password_2"
                type="password"
                :placeholder="$t(`비밀번호 한번 더 입력`)"
                aria-describedby="password_check_feedback"
                autocomplete="new-password"
                :disabled="calcLoading"
                :state="!form.password || !form.password_2 ? fieldState('password_2') : form.password === form.password_2"
            />
            <b-form-invalid-feedback id="password_check_feedback">
                {{ $t(`비밀번호를 동일하게 입력해 주세요`) }}
            </b-form-invalid-feedback>

            <div class="d-flex">
                <div class="w-25 mr-3">
                    <!-- 국가 코드 목록이 일부 국가뿐이라 필수로 두지 않는다(목록 밖 국가는 연락처에 직접 적는다) -->
                    <label for="input-company_country" class="d-block pt-3 pb-1 mb-0">{{ $t(`국가 코드`) }}</label>
                    <b-form-select id="input-company_country"
                                   v-model="form.national_code"
                                   :options="nation_codes"
                                   :text-field="$i18n.locale ===  'ko' ? 'text' : 'text_en'"
                                   value-field="value"
                                   :disabled="calcLoading"
                                   autocomplete="new-password"
                    >
                    </b-form-select>
                </div>

                <div class="w-75">
                    <label for="register-user-tel" class="d-block pt-3 pb-1 mb-0">* {{ $t(`연락처`) }}</label>
                    <b-form-input id="register-user-tel"
                                  v-model.trim="form.tel_office"
                                  aria-describedby="national-code-help-block"
                                  :placeholder="form.national_code === null ? `(+${($t('국가 코드'))}) 000-0000-0000` : '000-0000-0000'"
                                  :disabled="calcLoading"
                                  autocomplete="new-password"
                                  :state="fieldState('tel_office')"
                    />
                </div>
            </div>
        </template>
        <template v-if="phase_step === 2">
            <template v-if="!selected_vendor.validated">
                <label for="register-company-code" class="d-block pt-3 pb-1 mb-0">* {{ $t(`사업자등록번호`) }}</label>
                <!-- 회사에 이미 번호가 있으면 보여주기만 한다. 서버도 다른 값으로 바꾸는 요청은 거부한다 -->
                <b-form-input
                    v-if="existing_company_code"
                    id="register-company-code"
                    :value="existing_company_code"
                    disabled
                />
                <b-form-input
                    v-else
                    id="register-company-code"
                    v-model.trim="form.company_code"
                    :state="fieldState('company_code')"
                    :placeholder="$t(`사업자등록번호`)"
                    autocomplete="new-password"
                />
            </template>

            <template v-if="!has_service_request">
                <label for="register-report-lang" class="d-block pt-3 pb-1 mb-0">* {{ $t(`결과보고서 희망 언어`) }}</label>
                <b-form-select id="register-report-lang"
                               v-model="form.report_lang"
                               :options="report_lang_options"
                               :disabled="calcLoading"
                               @change="report_lang_touched = true"
                />
            </template>

            <template v-if="input_keys?.length > 0">
                <ProjectInputForm v-model="form" :input_keys="input_keys"
                                  :loading="calcLoading"
                />
            </template>
            
        </template>
        <template v-else-if="phase_step === 3 && is_user_duplicated">
            <div class="mt-3">
                <h5>{{ $t('이미 회원가입 하신 사용자이므로 3초후 평가신청 단계로 진행됩니다.') }}</h5>
                <!-- 업체·이메일을 잘못 골랐다면 신청이 나가기 전에 멈출 수 있게 한다(register_loading 과 무관하게 누를 수 있음) -->
                <b-btn v-if="auto_submit_waiting" variant="outline-secondary" size="sm" class="mt-2" @click="cancelAutoSubmit">{{ $t('취소') }}</b-btn>
            </div>
        </template>


        <InputConfirmModal :input_keys="input_keys"
                           :form="form"
                           @confirm="confirmSelection"
                           @cancel="cancelSelection"
        />

        <!-- 동의는 모달의 [확인] 으로만 성립한다 (체크만 하고 창을 닫은 것은 동의가 아님) -->
        <PrivacyAgree :privacy_agree="privacy_agree"
                      @goNext="agreedPrivacy"
        />

        <CommonRegisterFooter>
            <b-btn variant="blue"
                   :disabled="!selected_vendor || calcLoading"
                   @click="handleNext"
            >
                <b-spinner v-if="calcLoading" small class="mr-1"/>
                {{ $t(`다음`) }}
            </b-btn>
        </CommonRegisterFooter>
    </div>
</template>

<script>
import CommonRegisterFooter from '@/components/auth/Register/_SubComponents/CommonRegisterFooter.vue';
import {mapActions, mapState} from 'vuex';
import * as Sentry from '@sentry/vue';
import PrivacyAgree from '@/components/auth/Register/_SubComponents/RegisterStep2/PrivacyAgree.vue';
import InputConfirmModal from '@/components/auth/Register/_SubComponents/RegisterStep2/InputConfirmModal.vue';
import {inputKeyDescriptionHtml} from '@/components/auth/Register/_SubComponents/RegisterStep2/inputKeyDescription';
import {REGISTER_INQUIRY_MODAL_ID} from '@/components/auth/Register/_SubComponents/RegisterInquiryModal.vue';
import {tenant, mergeTenantRegister} from '@shared/utils/tenant';
import {nation_codes} from '@/components/auth/Register/_SubComponents/data';
import ProjectInputForm from '@/components/auth/Register/_SubComponents/RegisterStep2/ProjectInputForm.vue';
import {waitTime} from '@shared/utils/common';
import {localize} from 'vee-validate';
import {LOCALE_STORAGE_KEY} from '@/i18n';

const VERIFY_APPLICANT_URL = '/register/verification_user_project';
// 입력 칸 id (안내 후 포커스)
const FIELD_IDS = {
    user_name: 'register-user-name',
    password: 'register-user-password',
    password_2: 'register-user-password-2',
    tel_office: 'register-user-tel',
    company_code: 'register-company-code',
};

/**
 * Step 2 — 신청자 확인 → 정보 입력 → 신청.
 *
 * phase_step
 *   1: 이메일 입력 (가입 여부·중복 신청 확인 전)
 *   2: 정보 입력 (신규 가입자는 회원 정보까지, 기가입자는 신청 정보만)
 *   3: 기가입자 자동 진행 안내 ("3초 후 진행") — 신청 중에만 잠깐 보인다
 *
 * 서버 요청은 handleNext() 한 곳에서만 시작하고, 그동안 store.register_loading 으로
 * 모든 버튼·뒤로가기·로고를 막는다. 실패하면 이 화면에 머문 채(입력 유지) 에러 모달 하나만 띄운다.
 */
export default {
    name: 'RegisterStep2',
    components: {InputConfirmModal, ProjectInputForm, PrivacyAgree, CommonRegisterFooter},
    data() {
        return {
            form: {
                e_mail: '',
                user_name: '',
                password: '',
                password_2: '',
                tel_office: '',
                national_code: null,
                company_code: null,
                // 결과보고서 희망 언어 — 직접 고르기 전까지 화면 언어를 따라간다
                report_lang: this.$i18n.locale,
            },
            report_lang_touched: false,
            // 이 회사·프로젝트의 신청(df_nice_service_request)이 이미 있으면 true.
            // 결과보고서 희망 언어는 신청을 처음 만드는 사람만 고른다.
            has_service_request: false,
            input_keys: null,
            is_user_duplicated: false,
            // 개인정보 동의. 한 번 동의하면 실패 후 다시 신청할 때 다시 묻지 않는다.
            privacy_agree: false,
            // 캠페인 결정 항목(기업 규모 등) 재확인 완료 여부 — 해당 값을 바꾸면 다시 확인
            selectionConfirmed: false,
            campaign_id: null,
            // 신청이 반드시 실패하는 상태(프로젝트 설정 미완료 / 신청 준비 정보 조회 실패)면 진행을 막는다.
            // 개인정보를 받기 전에 막는 게 목적이다.
            blocked_message: null,
            // 조회 실패처럼 일시적인 차단이면 [다음] 을 다시 누를 때 준비 정보를 다시 받는다
            blocked_retryable: false,
            // 기가입자 자동 진행: 대기(3초) 중에만 [취소] 를 보인다. 취소했거나 화면을 떠났으면 신청하지 않는다
            auto_submit_waiting: false,
            auto_submit_canceled: false,
            // 필수값 누락 등으로 표시할 입력 칸 (form 키)
            invalid_field: null,
            phase_step: 1,
        };
    },
    computed: {
        ...mapState('register', ['register_loading', 'selected_vendor', 'remote_register_config']),
        tenant_register() {
            return mergeTenantRegister(tenant && tenant.register, this.remote_register_config);
        },
        // 재확인 게이트 — confirmGate 테넌트(steel)에서 기준 설명 있는 input_key 가 있을 때만
        hasCriteriaInputs() {
            if (!this.tenant_register || !this.tenant_register.confirmGate) return false;
            const locale = this.$i18n.locale;
            return (this.input_keys || []).some(item => !!inputKeyDescriptionHtml(item, locale));
        },
        // 재확인 대상 값 — 바뀌면 재확인을 다시 받는다
        criteriaSnapshot() {
            return JSON.stringify((this.input_keys || []).map(item => this.form[item.key_name]));
        },
        nation_codes() {
            return nation_codes;
        },
        calcLoading() {
            return this.register_loading;
        },
        existing_company_code() {
            return this.selected_vendor?.company?.company_code?.trim() || null;
        },
        // 첫 신청(미검증 벤더)인데 회사에 사업자번호가 없을 때만 입력받는다
        company_code_input_needed() {
            return !this.selected_vendor.validated && !this.existing_company_code;
        },
        // 기업명 / 소재지 — PC 표와 휴대폰 목록이 같은 값을 쓴다. 한국어는 국문 우선, 그 외는 영문 우선(없으면 다른 쪽), 빈 값은 뺀다
        company_label() {
            const c = this.selected_vendor?.company || {};
            const parts = this.$i18n.locale === 'ko'
                ? [c.company_name_dip, c.country || c.country_en]
                : [c.company_name_en_dip || c.company_name_dip, c.country_en || c.country];
            return parts.filter(Boolean).join(' / ') || '-';
        },
        // 사용자가 직접 입력한 값이 있는지 — 떠나기 전 확인 기준(국가 코드·희망 언어 기본값, 동적 항목 초기화는 입력이 아니다)
        has_user_input() {
            const f = this.form;
            return [f.e_mail, f.user_name, f.password, f.password_2, f.tel_office, f.company_code].some(Boolean)
                || this.report_lang_touched
                || (this.input_keys || []).some(item => f[item.key_name] !== null && f[item.key_name] !== '');
        },
        report_lang_options() {
            return [
                {text: '한국어', value: 'ko'},
                {text: 'English', value: 'en'},
                {text: '中文', value: 'ca'},
            ];
        },
    },
    watch: {
        '$i18n.locale'(locale) {
            if (!this.report_lang_touched) this.form.report_lang = locale;
        },
        criteriaSnapshot() {
            this.selectionConfirmed = false;
        },
        has_user_input: {
            immediate: true,
            handler(value) {
                this.setFormDirty(value);
            },
        },
        // 정보 입력 단계가 열리면 첫 입력 칸으로 (휴대폰에서 이메일 확인 뒤 다음 칸을 찾지 않게)
        async phase_step(step) {
            if (step !== 2) return;
            await this.$nextTick();
            const first = this.$el.querySelector('#register-user-name, #register-company-code:not([disabled])');
            if (first) first.focus();
        },
    },
    created() {
        if (this.selected_vendor?.company?.country) {
            this.form.national_code = this.nation_codes.find(item => {
                return item.text.includes(this.selected_vendor.company.country);
            })?.value || null;
        }
        this.runExclusive(() => this.loadRequestPrerequisites());
    },
    beforeDestroy() {
        // 대기 중에 화면을 떠나면(뒤로가기 등) 신청이 나가지 않게 한다
        this.auto_submit_canceled = true;
    },
    methods: {
        ...mapActions('register', ['setRegisterLoading', 'setDuplicated', 'completeRequest', 'setFormDirty']),
        onEnterKey(event) {
            // 링크·버튼의 Enter 는 그 자체의 클릭이다 — 입력 칸에서만 [다음] 으로 본다
            if (event.target.tagName === 'INPUT') this.handleNext();
        },
        editEmail() {
            this.phase_step = 1;
            this.is_user_duplicated = false;
            this.privacy_agree = false;
            this.$nextTick(() => document.getElementById('register-user-email')?.focus());
        },
        cancelAutoSubmit() {
            this.auto_submit_canceled = true;
            this.auto_submit_waiting = false;
            this.phase_step = 2;
        },
        fieldState(key) {
            if (this.invalid_field !== key) return null;
            if (key === 'password') return this.form.password.length >= 4 ? null : false;
            return this.form[key] ? null : false;
        },
        warn(message) {
            return this.$showModal({type: 'alert', state: 'warning', message});
        },

        // 서버 요청이 겹치지 않게 한 번에 하나만 실행한다. 이미 진행 중이면 무시.
        async runExclusive(task) {
            if (this.register_loading) return;
            this.setRegisterLoading(true);
            try {
                await task();
            } catch (error) {
                await this.handleError(error);
            } finally {
                this.setRegisterLoading(false);
            }
        },

        // 신청 준비: 이미 캠페인이 정해진 회사인지, 아니면 캠페인 판별 입력이 필요한지
        async loadRequestPrerequisites() {
            try {
                const assigned = await this.$axios.get('/register/company_project', {
                    params: {
                        project_id: this.selected_vendor.project,
                        company_id: this.selected_vendor.company.id,
                    },
                });
                if (assigned.status === 200) {
                    this.campaign_id = assigned.data.id;
                    this.has_service_request = true;
                    this.input_keys = null;   // 이미 정해진 캠페인으로 신청 — 판별 입력 불필요
                    return;
                }

                const {data} = await this.$axios.get(`/project-schema/projects/${this.selected_vendor.project}/schema`);

                // 백엔드가 "지금 이 프로젝트로 신청이 가능한가" 를 신청 API 와 같은 기준으로 계산해 준다.
                // 불가능하면 개인정보를 받기 전에 막는다 (prod 2026-07-23: 판별 불가인데 진행 → 422).
                if (data.campaign_resolution && !data.campaign_resolution.ready) {
                    this.block(this.$t('프로젝트 설정이 완료되지 않아 현재 평가를 신청할 수 없습니다. QESG로 문의해주세요.'));
                    return;
                }

                data.input_keys.forEach(item => {
                    if (item.value_type === 'list') {
                        item.allowed_values = item.allowed_values.map(value => ({
                            ...value,
                            label_ko: value.label_texts.ko,
                            label_en: value.label_texts.en,
                            label_ca: value.label_texts.ca,
                        }));
                    }
                    this.$set(this.form, item.key_name, null);
                });
                this.input_keys = data.input_keys;
            } catch (e) {
                // 판별 정보 없이 진행하면 개인정보를 다 받은 뒤 신청이 실패하므로 막는다. 일시적일 수 있어 [다음] 으로 다시 받는다
                this.block(this.$t('평가 신청에 필요한 정보를 받아오는데 실패했습니다. 다시 시도해주시거나 에러가 지속적으로 발생 시, QESG로 문의해주세요.'), true);
            }
        },
        block(message, retryable = false) {
            this.blocked_message = message;
            this.blocked_retryable = retryable;
            this.showError(message);
        },

        // 모달에서 [확인] → 동의 성립 후 이어서 진행
        agreedPrivacy() {
            this.privacy_agree = true;
            this.$bvModal.hide('register-privacy-agree');
            this.handleNext();
        },
        // 재확인 모달: [확인하고 계속] → 이어서 진행 / [다시 선택] → 모달만 닫힘
        confirmSelection() {
            this.selectionConfirmed = true;
            this.$bvModal.hide('register-input-confirm');
            this.handleNext();
        },
        cancelSelection() {
            this.selectionConfirmed = false;
        },

        handleNext() {
            if (this.blocked_message && !this.blocked_retryable) {
                this.showError(this.blocked_message);
                return;
            }
            return this.runExclusive(async () => {
                if (this.blocked_message) {
                    // 일시적인 조회 실패 — 준비 정보를 다시 받고, 되면 그대로 이어서 진행한다
                    this.blocked_message = null;
                    await this.loadRequestPrerequisites();
                    if (this.blocked_message) return;
                }
                await (this.phase_step === 1 ? this.checkApplicant() : this.proceed());
            });
        },

        // Phase 1: 이메일로 가입 여부·중복 신청 확인
        async checkApplicant() {
            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (this.isFieldEmpty(this.form.e_mail) || !emailRegex.test(this.form.e_mail)) {
                this.warn(this.$t('이메일을 정확히 입력하여 주십시오.'));
                return;
            }

            const {data} = await this.$axios.get(VERIFY_APPLICANT_URL, {
                params: {
                    email: this.form.e_mail,
                    vendor_code: this.selected_vendor?.vendor_code,
                    project_code: this.selected_vendor?.project_code,
                },
            });

            this.is_user_duplicated = !!data.user;
            this.phase_step = 2;

            // 기가입자는 회원정보·동의 없이, 캠페인이 이미 정해졌으면 바로 신청까지 진행
            if (this.is_user_duplicated) {
                this.privacy_agree = true;
                if (this.campaign_id != null) await this.proceed();
            }
        },

        // Phase 2: 입력 검증 → (재확인) → (동의) → 신청
        async proceed() {
            if (!this.is_user_duplicated && !this.formValidationCheck()) return;
            if (this.company_code_input_needed && !this.validateCompanyCode()) return;
            if (this.input_keys?.length > 0 && !this.projectKeyValidationCheck()) return;

            if (this.hasCriteriaInputs && !this.selectionConfirmed) {
                this.$bvModal.show('register-input-confirm');
                return;
            }
            if (!this.privacy_agree) {
                this.$bvModal.show('register-privacy-agree');
                return;
            }

            if (this.is_user_duplicated) {
                // "이미 회원가입 하신 사용자이므로 3초후 평가신청 단계로 진행됩니다." 안내를 보여준 뒤 진행 ([취소] 로 멈출 수 있음)
                this.phase_step = 3;
                this.auto_submit_canceled = false;
                this.auto_submit_waiting = true;
                await waitTime(3000);
                // 대기가 끝나면 전송 단계 — 이때부터는 취소할 수 없으므로 버튼을 숨긴다
                this.auto_submit_waiting = false;
                if (this.auto_submit_canceled) return;
            }
            try {
                await this.submit();
            } finally {
                // 실패해도 입력 화면으로 돌아와 그대로 다시 신청할 수 있게 한다
                this.phase_step = 2;
            }
        },

        async submit() {
            let campaign_id = this.campaign_id;
            const project_input_form = {};
            (this.input_keys || []).forEach(item => {
                project_input_form[item.key_name] = this.form[item.key_name];
            });
            if (campaign_id == null && Object.keys(project_input_form).length > 0) {
                const {data} = await this.$axios.post('/rule-engine/evaluate/match-campaign', {
                    project_id: this.selected_vendor?.project,
                    user_inputs: project_input_form,
                });
                campaign_id = data?.campaign_id;
            }

            const vendor = this.selected_vendor;
            const body = {
                project_code: vendor?.project_code,
                campaign_id,
                company_id: vendor?.company?.id,
                // company_code 는 '저장할 번호' — 새로 입력한 경우만 보낸다 (저장할 수 없는 번호면 서버가 422)
                company_code: this.company_code_input_needed ? this.form.company_code : undefined,
                vendor_code: vendor?.vendor_code,
                email: this.form.e_mail,
                lang: this.$i18n.locale,
                report_lang: this.has_service_request ? undefined : this.form.report_lang,
            };
            if (!this.is_user_duplicated) {
                body.user_name = this.form.user_name;
                body.password = this.form.password;
                body.tel_office = !this.form.national_code
                    ? this.form.tel_office
                    : `(${this.form.national_code}) ${this.form.tel_office}`;
            }

            const {data} = await this.$axios.post('/register/request', body);

            this.breadcrumb('Info');
            this.$EventBus.$emit('toast-success', this.$t('회원가입 완료'), this.$t('QESG 평가신청이 완료되었습니다'));
            this.completeRequest(data);
        },

        handleError(error) {
            const {status, data} = error?.response || {};
            this.breadcrumb('Error', data?.message || error?.message);

            // 이 이메일로 이미 이 프로젝트에 신청돼 있음 → 중복 신청 안내 화면
            // 서버는 상태(access_status·role·create_date)만 준다 — 회사명·이메일은 화면이 아는 값
            if (status === 409 && data?.message === 'Duplicated_Project_Request') {
                // create_date 는 원본 그대로 — 표시 형식은 DuplicatedRequestInfo 가 화면 언어로 정한다
                const request = {
                    ...data.request,
                    company_name: this.selected_vendor?.company?.company_name,
                    email: this.form.e_mail,
                };
                this.setDuplicated({message: request, email: this.form.e_mail});
                return;
            }

            // 같은 회사의 다른 담당자가 먼저 신청함(업체는 프로젝트에 한 번만 참여) → 그 신청으로 다시 신청
            if (status === 409 && data?.message === 'Project_Already_Requested') {
                this.showError(this.$t('같은 회사의 다른 담당자가 이 프로젝트에 먼저 신청했습니다. [다음] 버튼을 다시 누르면 기존 신청에 함께 등록됩니다.'));
                return this.loadRequestPrerequisites();
            }

            // 취소된 신청도 '신청 있음' — 다시 신청할 수 없고 QESG 확인이 필요하다
            if (status === 409 && data?.message === 'Project_Request_Canceled') {
                this.block(this.$t('이 회사의 이 프로젝트 신청은 취소된 상태입니다. QESG로 문의해주세요.'));
                return;
            }

            // 메일 발송 실패 = 신청 미완료(서버가 롤백). 잠시 후 그대로 다시 신청하면 된다.
            if (data?.code === 'email_failure') {
                this.showError(this.$t('이메일 전송에 실패하여 평가 신청이 완료되지 않았습니다. 잠시 후 다시 신청해주세요.'));
                return;
            }

            // 서버가 구분해 주는 신청 거절 사유 (register.py /request — DefaultException 의 message 그대로)
            const message = typeof data?.message === 'string' ? data.message : '';
            if (status === 422 && message === 'Company_Code_Not_Editable') {
                // 번호가 이미 있을 때뿐 아니라 이 업체코드에 관리자가 이미 있을 때도 난다 — 원인을 단정하지 않는다
                this.showError(this.$t('이 회사의 사업자등록번호는 신청 화면에서 등록하거나 바꿀 수 없습니다. QESG로 문의해주세요.'));
                return;
            }
            if ((status === 422 && message.startsWith('campaign_id is required')) || (status === 404 && message.startsWith('not found campaign'))) {
                this.showError(this.$t('프로젝트 설정이 완료되지 않아 현재 평가를 신청할 수 없습니다. QESG로 문의해주세요.'));
                return;
            }
            if (status === 404 && /^not found (vendor|company|project)/.test(message)) {
                this.showError(this.$t('선택한 업체의 신청 정보를 찾을 수 없습니다. 업체코드를 다시 조회하거나 QESG로 문의해주세요.'));
                return;
            }
            // 이메일 확인 요청 자체가 실패한 경우만 (이어지는 신청 실패는 아래 일반 안내)
            if (error?.config?.url === VERIFY_APPLICANT_URL) {
                this.showError(this.$t('이메일 확인에 실패했습니다. 잠시 후 다시 시도해주세요.'));
                return;
            }
            this.showError(this.$t('평가 신청에 실패했습니다. 잠시 후 다시 시도해주시거나, 문제가 계속되면 QESG로 문의해주세요.'));
        },
        // 실패 안내는 이 모달 하나. [문의하기] 를 누르면 문의 창을 연다.
        async showError(message) {
            const inquire = await this.$showModal({
                type: 'confirm',
                state: 'error',
                title: this.$t('평가 신청 오류'),
                message,
                modalOptions: {okTitle: this.$t('문의하기'), cancelTitle: this.$t('닫기')},
            });
            if (inquire) this.$bvModal.show(REGISTER_INQUIRY_MODAL_ID);
        },
        breadcrumb(level, message) {
            Sentry.addBreadcrumb({
                level,
                type: 'Auth',
                category: 'Register',
                data: {
                    email: this.form.e_mail,
                    vendor_code: this.selected_vendor?.vendor_code,
                    company_name: this.selected_vendor?.company?.company_name,
                    message,
                },
            });
        },

        // 첫 누락·오류 칸을 짚어 안내하고, 창을 닫으면 그 칸으로 옮긴다
        invalidField(key, message) {
            this.invalid_field = key;
            this.warn(message).then(() => document.getElementById(FIELD_IDS[key])?.focus());
            return false;
        },
        formValidationCheck() {
            const required = [['user_name', '성함'], ['password', '비밀번호'], ['password_2', '비밀번호 확인'], ['tel_office', '연락처']];
            const missing = required.find(([key]) => !this.form[key]);
            if (missing) {
                return this.invalidField(missing[0], this.$t('필수 입력 항목인 {name}을(를) 입력해주세요.', {name: this.$t(missing[1])}));
            }
            // 안내(placeholder '4자리 이상')와 맞춘다 — 서버는 빈 값만 거부한다
            if (this.form.password.length < 4) {
                return this.invalidField('password', this.$t('비밀번호는 4자리 이상 입력해주세요.'));
            }
            if (this.form.password !== this.form.password_2) {
                return this.invalidField('password_2', this.$t('비밀번호 확인을 위해 정확히 기재해주세요.'));
            }
            this.invalid_field = null;
            return true;
        },
        projectKeyValidationCheck() {
            const missing = this.input_keys.find(item =>
                item.is_required && (this.form[item.key_name] === null || this.form[item.key_name] === ''));
            if (missing) {
                const name = missing.label_texts?.[this.$i18n.locale] || missing.label_texts?.ko;
                this.warn(this.$t('필수 입력 항목인 {name}을(를) 입력해주세요.', {name}));
                return false;
            }
            return true;
        },
        // 한국 사업자등록번호 체크섬
        isKrBusinessNumber(number) {
            const digits = number.replace(/-/g, '').split('').map(d => parseInt(d, 10));
            if (digits.length !== 10) return false;
            const keys = [1, 3, 7, 1, 3, 7, 1, 3, 5];
            let sum = keys.reduce((acc, k, i) => acc + k * digits[i], 0);
            sum += Math.floor((keys[8] * digits[8]) / 10);
            return digits[9] === (10 - (sum % 10)) % 10;
        },
        validateCompanyCode() {
            if (this.isFieldEmpty(this.form.company_code)) {
                this.invalidField('company_code', this.$t('사업자 코드를 입력해주세요.'));
                return false;
            }
            // 한국어 화면에서만 한국 사업자번호로 검사한다. 해외 기업일 수 있으니 막지 않고 영어 전환을 권한다.
            if (this.$i18n.locale === 'ko' && !this.isKrBusinessNumber(this.form.company_code.trim())) {
                this.showOverseasBusinessNumberModal();
                return false;
            }
            return true;
        },
        // 한국어 UI 에서 한국 사업자등록번호 체크섬에 실패한 경우:
        // 해외(대한민국 외) 등록 기업일 수 있으므로, alert 로 막지 않고
        // 언어를 English 로 전환하도록 유도한다. 전환해도 입력값은 유지된다
        // (locale 반응형 대입 + localize 만 수행, 리로드/재마운트 없음).
        showOverseasBusinessNumberModal() {
            const h = this.$createElement;
            const message = h('div', [
                h('p', {class: 'mb-2'}, '입력하신 번호는 대한민국 사업자등록번호로 확인되지 않습니다. 대한민국 외 국가에 등록된 기업이라면 화면 언어를 English 로 변경한 뒤 다시 신청해 주세요. 입력하신 정보는 그대로 유지됩니다.'),
                h('p', {class: 'mb-0 text-secondary'}, 'This number is not recognized as a Korean business registration number. If your company is registered outside Korea, switch the language to English and continue. Your entered information will be kept.'),
            ]);
            this.$showModal({
                type: 'confirm',
                state: 'warning',
                title: '사업자등록번호 확인 / Business Registration Number',
                message,
                modalOptions: {
                    okTitle: 'English 로 전환 / Switch to English',
                    cancelTitle: '닫기 / Close',
                },
            }).then((confirmed) => {
                if (!confirmed) return;
                // 언어 드롭다운과 같게 저장값·html lang 까지 바꾸고, 주소에 ?l= 이 있으면 맞춘다(새로고침 시 되돌아가지 않게)
                this.$i18n.locale = 'en';
                localize('en');
                document.documentElement.lang = 'en';
                try {
                    localStorage.setItem(LOCALE_STORAGE_KEY, 'en');
                } catch (e) { /* 저장소 접근 불가 — 이번 화면만 */ }
                if (this.$route.query.l && this.$route.query.l !== 'en') {
                    this.$router.replace({query: {...this.$route.query, l: 'en'}, hash: this.$route.hash}).catch(() => {});
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>

</style>
